import axios from 'axios';
import { toast } from 'react-toastify';

let handlingAuthError = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';

    if ((status === 401 || status === 403) && !url.includes('/auth/')) {
      if (!handlingAuthError) {
        handlingAuthError = true;
        try {
          toast.error('Tu sesión expiró, vuelve a iniciar sesión');
        } catch (_) {}
        setTimeout(() => {
          localStorage.clear();
          window.location.href = '/';
        }, 400);
      }
    }

    return Promise.reject(error);
  }
);
